import {
  getAllAdministrationUsers,
  getUserDetailsError,
  getUserDetailsLoading,
  getUsersBySelectKey,
  getUsersLoadingBySelectKey,
} from 'gcs-common/slices/administration/administrationUsers/administrationUsersSelectors';
import {
  fetchListOfUserDetails,
  fetchSelectUsers,
} from 'gcs-common/slices/administration/administrationUsers/administrationUsersThunks';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormikSelect from '../../../FormikSelect/FormikSelect';

interface FormikUserSelectProps {
  userType: string;
  name: string;
  selectKey: string;
  placeholder?: string;
  initialUserIds: string[];
  houseId?: string;
  labelKey: string;
  valueKey: string;
  onChange?: (value: string) => void;
  isMulti?: boolean;
  localFilter?: string[];
  companyId?: string;
  initialValue?: string[];
}

const FormikUserSelect = (props: FormikUserSelectProps) => {
  const {
    selectKey,
    name,
    placeholder = 'Suchen...',
    labelKey,
    valueKey,
    isMulti = false,
    userType,
    onChange,
    houseId,
    initialUserIds,
    localFilter,
    initialValue,
    companyId,
    ...otherProps
  } = props;

  const allUsers = useSelector(getAllAdministrationUsers);
  const users = useSelector(getUsersBySelectKey(selectKey));
  const usersLoading = useSelector(getUsersLoadingBySelectKey(selectKey));
  const userLoading = useSelector(getUserDetailsLoading(initialUserIds));
  const userError = useSelector(getUserDetailsError(initialUserIds));

  const dispatch = useDispatch();

  useEffect(() => {
    if (initialUserIds && initialUserIds.length > 0) {
      // @ts-expect-error redux
      dispatch(fetchListOfUserDetails({ userIds: initialUserIds }));
    }
  }, [dispatch, initialUserIds]);

  const initialValues = useMemo(() => {
    if (initialUserIds) {
      return Object.values(allUsers).map((user) => user);
    }
    if (initialValue) {
      return initialValue;
    }
    return undefined;
  }, [initialUserIds, initialValue, allUsers]);

  const getUsers = useCallback(
    (searchQuery: string) => {
      dispatch(
        // @ts-expect-error redux
        fetchSelectUsers({
          selectKey,
          pageIndex: 0,
          pageSize: 50,
          houseId,
          searchQuery,
          userType,
          erpCustomerId: companyId,
        }),
      );
    },
    [dispatch, selectKey, houseId, userType, companyId],
  );

  return (
    <FormikSelect
      name={name}
      hasError={userError}
      placeholder={placeholder}
      labelKey={labelKey}
      valueKey={valueKey}
      isMulti={isMulti}
      onChange={onChange}
      isLoading={usersLoading || userLoading}
      options={!isMulti && initialValue ? [initialValue, ...users] : users}
      onInputChange={getUsers}
      initialValue={initialValues}
      localFilter={localFilter}
      {...otherProps}
      // This field is used for displaying the selected option
      formatOptionLabel={(option) => option[labelKey]}
      // This field is used in filtering the options via the search text
      getOptionLabel={(option) => `${option[labelKey]} ${option.email}`}
    />
  );
};

export default FormikUserSelect;
